export const SET_SPEARKER = "SET_SPEARKER";

export const setSpeaker = (speaker) => {
  return {
    type: SET_SPEARKER,
    payload: speaker,
  };
};
